import jsdk from './jsdk';

var CLICK = 'click';

// Rappresenta una finestra modale generica
// Si possono aprire più modali contemporaneamente
// e si può specificare se l'utente può chiuderla o meno
function Modal( width, body, is_closable) {

  jsdk.assert(jsdk.Natural.is(width));
  jsdk.assert(jsdk.Str.is(body));
  jsdk.assert(jsdk.Bool.is(is_closable));
  this.width = width;
  this.body = body;
  this.is_closable = is_closable;
  return jsdk.freeze(this);
}

Modal.overlay = function(attrs) {
  attrs = attrs ? jsdk.copy(attrs) : {};
  attrs['class'] = attrs['class'] || [];
  attrs['class'].push('overlay');
  return '<div' + jsdk.attr(attrs) + '></div>';
};

Modal.header = function(s) {
  return '<div class="modal-header">' + s + "</div>";
};

Modal.section = function(s) {
  return '<div class="modal-section">' + s + "</div>";
};

Modal.footer = function(s) {
  return '<div class="modal-footer">' + s + "</div>";
};

Modal.close_button = function() {
  return '<div class="modal-close"></div>';
};

Modal.prototype.to_html = function() {
  return [
    '<div id="modal-container">',
    Modal.overlay(),
    '<div class="modal">',
    '<div', jsdk.attr({
      'class': 'modal-body',
      style: {
        'max-width': this.width
      }
    }), '>',
    this.is_closable ? Modal.close_button() : "",
    this.body,
    '</div>',
    '</div>',
    '</div>'
  ].join('');
};

Modal.prototype.to_widget = function() {
  var self = this;
  var start = function() {
    $('#modal-container').on(CLICK, '.modal-close', function() {
      stop();
    });
    // scroll top
    $('html, body').animate({
      scrollTop: 0
    }, 'fast');

  };
  var stop = function() {
    $('#modal-container').off().remove();
  };
  return new jsdk.Widget(self.to_html(), start, stop);
};

// Rappresenta l'interfaccia di una finestra di dialogo in cui
// la modale è divisa in tre parti
// - l'header opzionale
// - la sezione centrale obbligatoria
// - il footer opzionale
function Dialog(width, body, footer, header) {
  jsdk.assert(jsdk.Natural.is(width));
  jsdk.assert(jsdk.Str.is(body));
  jsdk.assert(jsdk.Maybe(jsdk.Str).is(body));
  jsdk.assert(jsdk.Maybe(jsdk.Str).is(body));
  this.width = width;
  this.body = body;
  this.footer = footer;
  this.header = header;
  return jsdk.freeze(this);
}

Dialog.prototype.to_widget = function() {
  var content = [
    this.header ? Modal.header(this.header) : '',
    Modal.section(this.body),
    this.footer ? Modal.footer(this.footer) : ''
  ].join('');
  var modal = new Modal(this.width, content, false);
  return modal.to_widget();
};

// Rappresenta l'interfaccia di una finestra di alert
// Il locale serve per mostrare il bottone di chisura localizzato
function Alert(locale, width, body, opt_header) {
  jsdk.assert(jsdk.Locale.is(locale));
  jsdk.assert(jsdk.Natural.is(width));
  jsdk.assert(jsdk.Str.is(body));
  jsdk.assert(jsdk.Maybe(jsdk.Str).is(opt_header));
  this.locale = locale;
  this.width = width;
  this.body = body;
  this.header = opt_header;
  return jsdk.freeze(this);
}

Alert.prototype.to_widget = function(options) {
  options = options || {};
  var locale = this.locale;
  var close = locale.language_bundle().button.close;
  var footer = [
    jsdk.dom.button(close, {
      id: 'do_close_alert'
    })
  ].join('');
  var dialog = new Dialog(this.width, this.body, footer, this.header);
  var widget = dialog.to_widget();
  var start = function() {
    widget.start();
    $('#modal-container').on(CLICK, '#do_close_alert', function() {
      stop();
    });
    if (options.start) {
      options.start(dialog);
    }
  };
  var stop = function() {
    widget.stop();
    if (options.stop) {
      options.stop(dialog);
    }
  };
  return new jsdk.Widget(widget.to_html(), start, stop);
};

Alert.go = function(locale, width, body, opt_header, options) {
  var a = new Alert(locale, width, body, opt_header, options);
  var w = a.to_widget(options);
  $('body').append(w.to_html());
  w.start();
  return w;
};

function Confirm(locale, width, body, opt_header) {
  //jsdk.assert(jsdk.Locale.is(locale));
  jsdk.assert(jsdk.Natural.is(width));
  jsdk.assert(jsdk.Str.is(body));
  jsdk.assert(jsdk.Maybe(jsdk.Str).is(opt_header));
  this.locale = locale;
  this.width = width;
  this.body = body;
  this.header = opt_header;
  return jsdk.freeze(this);
}

// Rappresenta l'interfaccia di una finestra di richiesta comferma
// Il locale serve per mostrare i bottoni localizzati
Confirm.prototype.to_widget = function(callback) {
  jsdk.assert(jsdk.Func.is(callback));
  var locale = this.locale;
  var bundle = locale.language_bundle().bool;
  var yes = bundle.TRUE;
  var no = bundle.FALSE;
  var footer = [
    jsdk.dom.button(yes, {
      id: 'do_yes'
    }),
    jsdk.dom.button(no, {
      id: 'do_no',
      'class': ['primary']
    })
  ].join('');
  var dialog = new Dialog(this.width, this.body, footer, this.header);
  var widget = dialog.to_widget();
  var start = function() {
    widget.start();
    $('#modal-container')
      .on(CLICK, '#do_yes', function() {
        stop();
        callback(true);
      })
      .on(CLICK, '#do_no', function() {
        stop();
        callback(false);
      });
  };
  var stop = function() {
    widget.stop();
  };
  return new jsdk.Widget(widget.to_html(), start, stop);
};

Confirm.go = function(callback, locale, width, body, opt_header) {
  var c = new Confirm(
    locale,
    width,
    body,
    opt_header
  );
  var w = c.to_widget(callback);
  $('body').append(w.to_html());
  w.start();
};

function Prompt(locale, width, form, opt_header, opt_focus) {
  jsdk.assert(jsdk.Locale.is(locale));
  jsdk.assert(jsdk.Natural.is(width));
  jsdk.assert(jsdk.Form.is(form));
  jsdk.assert(jsdk.Maybe(jsdk.Str).is(opt_header));
  this.locale = locale;
  this.width = width;
  this.form = form;
  this.header = opt_header;
  this.focus = opt_focus;
  return jsdk.freeze(this);
}

Prompt.prototype.to_widget = function(callback) {
  var self = this;
  var locale = this.locale;
  var bundle = locale.language_bundle().button;
  var ok = bundle.ok;
  var close = bundle.close;
  var footer = [
    jsdk.dom.button(ok, {
      id: 'do_prompt_ok',
      'class': ['primary']
    }),
    jsdk.dom.button(close, {
      id: 'do_prompt_close'
    })
  ].join('');
  var form = this.form;
  var dialog = new Dialog(this.width, form.to_html(), footer, this.header);
  var widget = dialog.to_widget();
  var start = function() {
    widget.start();
    if (self.focus) {
      form.start_and_focus();
    }
    else {
      form.start();
    }
    $('#do_prompt_ok').on(CLICK, function() {
      var value = form.value();
      if (value) {
        if (callback(value)) {
          stop();
        }
      }
    });
    $('#do_prompt_close').on(CLICK, function() {
      if (callback(null)) {
        stop();
      }
    });
    /*$('#modal-container').on(CLICK, '#do_prompt_ok', function() {
        var value = form.value();
        if (value) {
          if (callback(value)) {
            stop();
          }
        }
      })
      .on(CLICK, '#do_prompt_close', function() {
        if (callback(null)) {
          stop();
        }
      });*/
  };
  var stop = function() {
    form.stop();
    widget.stop();
    $('#modal-container').off().remove();
  };
  return new jsdk.Widget(widget.to_html(), start, stop);
};

Prompt.go = function(callback, locale, width, config, data, opt_header, opt_focus) {
  var p = new Prompt(locale, width, config, data, opt_header, opt_focus);
  var w = p.to_widget(callback);
  $('body').append(w.to_html());
  w.start();
};

exports.Modal = Modal;
exports.Dialog = Dialog;
exports.Alert = Alert;
exports.Confirm = Confirm;
exports.Prompt = Prompt;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/dialog.js
 **/